import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getDevicesTester } from './firebase';
import {
  STATUS_FETCHING,
  STATUS_ERROR,
  STATUS_READY,
  STATUS_IDLE
} from './constants';

export const fetchDevicesTester = createAsyncThunk('getTesterDeviceS', async (nip) => await getDevicesTester(nip));

const testerDeviceSlice = createSlice({
  name: 'testerDevice',
  initialState: {
    status: STATUS_IDLE,
    data: []
  },
  reducers: {},
  extraReducers (builder) {
    builder
      .addCase(fetchDevicesTester.pending, (state, action) => {
        state.status = STATUS_FETCHING
      })
      .addCase(fetchDevicesTester.fulfilled, (state, action) => {
        state.status = STATUS_READY
        state.data = action.payload
      })
      .addCase(fetchDevicesTester.rejected, (state, action) => {
        state.status = STATUS_ERROR
        state.error = action.error.message
      })
  }
})

export default testerDeviceSlice.reducer
